<template>
  <form id="FormularioCrud" class="columns is-multiline" @submit.prevent="sendForm">
    <b-field class="column is-12" label="Nombre *" label-position="horizontal">
      <b-input v-model="form.nombres" type="text" required></b-input>
    </b-field>

    <b-field class="column is-12" label="Correo *" label-position="horizontal">
      <b-input v-model="form.email" type="email" required></b-input>
    </b-field>

    <b-field class="column is-12" :label="!form.id ? 'Contraseña *' : 'Contraseña'" label-position="horizontal">
      <b-input v-model="form.password" type="password" :required="!form.id" password-reveal></b-input>
    </b-field>

    <b-field class="column is-12" label="Desactivar acceso" label-position="horizontal">
      <b-switch v-model="form.bloquear_acceso"></b-switch>
    </b-field>

    <b-button class="is-success" type="submit" native-type="submit" label="Guardar" expanded></b-button>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
  props: {
    datavalues: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {},
      initialFormState: {
        id: null,
        nombres: '',
        email: '',
        password: '',
        bloquear_acceso: false,
      },
    };
  },
  watch: {
    datavalues: {
      immediate: true,
      handler(newData) {
        this.loadFormData(newData);
      },
    },
  },
  methods: {
    ...mapActions({
      submitForm: 'administrators/submitForm', // Asegúrate de tener esta acción en Vuex
    }),
    async loadFormData() {
      if (this.datavalues && Object.keys(this.datavalues).length) {
        Object.keys(this.initialFormState).forEach((key) => {
          this.form[key] = this.datavalues[key] ?? this.initialFormState[key];
        });

        this.form.password = this.initialFormState.password;
        this.form.bloquear_acceso = this.datavalues.bloquear_acceso == '1' || this.initialFormState.bloquear_acceso;
      } else {
        this.form = { ...this.initialFormState };
      }
    },
    async sendForm() {
      const payload = {
        ...this.form,
        jefe_seccion: this.form.bloquear_acceso ? 1 : 0,
      };

      const response = await this.submitForm(payload);

      Swal.fire({
        icon: response.status ? 'info' : 'error',
        title: response.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
      });

      if (response.status) {
        this.$store.commit('administrators/SET_DATA', { key: 'reloadList', data: true });
        this.closeForm();
      }
    },
    closeForm() {
      this.$emit('close-form');
    },
  },
};
</script>

<style scoped>
.form-horizontal {
  max-width: 600px;
  margin: auto;
}
</style>
